import styled from "styled-components";

import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";

export const StyledNavbar = styled.nav`
  background: #000;
  background: ${({ scrollNav }) => (scrollNav ? "#000" : "transparent")};
  height: 80px;
  margin-top: -80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: 0.8s all ease;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`
  /* color: ${({ theme }) => theme.colors.contrast}; */
  color: #fff;
  display: flex;
  align-items: center;
  margin-left: 24px;

  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
`;

export const MobileIcon = styled.div`
  display: none; //will not show

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: auto;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
  display: flex; //default flex direction is row
  align-items: center;
  list-style: none;
  text-align: center;
  /* margin-right: -22px; */
  margin-right: 70px;
  @media (max-width: ${({ theme }) => theme.mobile}) {
    display: none; //the row version of the navbar will not show once the screen shrink to a certain size
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavLinks = styled(LinkS)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &.active {
    border-bottom: 5px solid ${({ theme }) => theme.colors.contrast}; // make to be purple later
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    display: none; //the row version of the navbar will not show once the screen shrink to a certain size
  }
`;

export const NavBtnLink = styled(LinkS)`
  border-radius: 50px;
  background: ${({ theme }) => theme.colors.contrast};
  white-space: nowrap;
  padding: 10px 22px;

  color: #fff;
  outline: none;
  font-size: 16px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: ${({ theme }) => theme.colors.contrast};
    transform: scale(0.95);
  }
`;
